import Image from 'next/image';
import styled, { css } from 'styled-components';
import { SvgHelperWrapper } from 'src/components';
import _Section from '../../Section';
import _Card from '../Card';

export const Section = styled(_Section)(
  ({ theme }) => css`
    display: flex;
    padding-bottom: ${theme.sz.s6};
    background-color: ${theme.co.neutral0};
  `,
);

export const SectionContent = styled(_Section.Content)(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s6};
  `,
);

export const Card = styled(_Card)(
  () => css`
    @media (max-width: 1152px) {
      display: none;
    }
  `,
);

export const ImageWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    overflow: hidden;
    aspect-ratio: 137/148;
    margin-bottom: ${theme.sz.s0};

    @media (min-width: ${theme.sz.sm}) {
      aspect-ratio: 1104/301;
      margin-bottom: ${theme.sz.s4};
    }
  `,
);

export const DesktopImage = styled(Image)(
  ({ theme }) => css`
    display: none;

    @media (min-width: ${theme.sz.sm}) {
      display: block;
    }
  `,
);

export const MobileImage = styled(Image)(
  ({ theme }) => css`
    @media (min-width: ${theme.sz.sm}) {
      display: none;
    }
  `,
);

export const CinemaDate = styled(SvgHelperWrapper)(
  ({ theme }) => css`
    max-width: ${theme.sz.ms};
  `,
);
